export const Abstract02Icon = () => {
  return (
    <svg
      width="125"
      height="125"
      viewBox="0 0 125 125"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M79.4447 65.6753C85.3999 63.2904 93.2384 62.2843 103.429 62.1973C93.2384 62.1102 85.3999 61.1037 79.4447 58.7188C81.5228 44.1933 96.5712 28.7024 124.594 0.196854C96.0882 28.2199 80.5977 43.2682 66.0718 45.3463C63.6873 39.3911 62.6808 31.5522 62.5938 21.3619C62.5067 31.5522 61.5002 39.3911 59.1157 45.3463C44.5898 43.2682 29.0993 28.2199 0.59375 0.196854C28.6163 28.7024 43.6647 44.1933 45.7428 58.7188C39.7876 61.1037 31.9491 62.1102 21.7588 62.1973C31.9491 62.2843 39.7876 63.2904 45.7428 65.6753C43.6647 80.2008 28.6163 95.6918 0.59375 124.197C29.0993 96.1743 44.5898 81.1264 59.1157 79.0483C61.5002 85.0035 62.5067 92.8419 62.5938 103.032C62.6808 92.8419 63.6873 85.0035 66.0718 79.0483C80.5977 81.1264 96.0882 96.1743 124.594 124.197C96.5712 95.6918 81.5228 80.2008 79.4447 65.6753Z"
        fill="url(#paint0_linear_1866_18416)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1866_18416"
          x1="62.5937"
          y1="0.196854"
          x2="62.5938"
          y2="124.197"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0.08" />
        </linearGradient>
      </defs>
    </svg>
  );
};
